import { IComponentOptions, IController } from "angular";
import { ItemType } from "@gtmhub/okrs/alignment-tree";
import { IMetric, isContributingMetric } from "@gtmhub/okrs/metrics";
import { IPlanningSession } from "@gtmhub/sessions";
import { ContributorType, IGoal, IGoalChildReorderResponse } from "@gtmhub/goals/models";
import { GhDndListComponentCtrl, GhDndListItemComponentCtrl } from "@gtmhub/shared/components";
interface IContributorComponentBindings {
  goal: IGoal;
  planningSession: IPlanningSession;
  allowedActions: string[];
  isTrialAccount: boolean;
  isAllowedToSubmitToMarketplace: boolean;
  addChildObjective(itemId: string, itemType: ItemType, itemSessionId: string): void;
  openMoveMetricModal(metric: IMetric): void;
  cloneMetricHere(metric: IMetric): void;
  openCloneMetricModal(metric: IMetric): void;
  openDisableSyncModal(metricId: string): void;
  confirmDeleteMetric(index: number, metricId: string): void;
  canUpdateMetric(metric: IMetric): boolean;
  goalUnlockedAndSessionOpen(): boolean;
  sessionWorkflowHasMetricFields: boolean;
  handleOpenCascadingForm(metric: IMetric, goalName: string): void;
  canCascadeMetric(metric: IMetric): void;
  copyItemUrlToClipboard(itemId: string, type: "metric" | "goal"): void;
}

export interface ContributorComponentCtrl extends IContributorComponentBindings {
  ghDndList: GhDndListComponentCtrl<IGoalChildReorderResponse, ContributorType>;
  ghDndListItem: GhDndListItemComponentCtrl<ContributorType>;
  type: "goal" | "metric";
  contributor: ContributorType;
  metric?: IMetric;
  isContributingMetric: boolean;
}

export class ContributorComponentCtrl implements IController {
  $onInit(): void {
    this.contributor = this.ghDndListItem.item;
    this.type = this.contributor.childType;

    if (this.ghDndListItem.item.childType === "metric") {
      this.metric = this.ghDndListItem.item;
      this.isContributingMetric = isContributingMetric(this.metric);
    }
  }
}

export const ContributorComponent: IComponentOptions = {
  templateUrl: require("./contributor.component.jade"),
  controller: ContributorComponentCtrl,
  require: { ghDndListItem: "^", ghDndList: "^" },
  bindings: {
    goal: "<",
    planningSession: "<",
    allowedActions: "<",
    isTrialAccount: "<",
    isAllowedToSubmitToMarketplace: "<",
    addChildObjective: "<",
    openMoveMetricModal: "<",
    cloneMetricHere: "<",
    openCloneMetricModal: "<",
    openDisableSyncModal: "<",
    confirmDeleteMetric: "<",
    canUpdateMetric: "<",
    isGoalAbandoned: "<",
    goalUnlockedAndSessionOpen: "<",
    sessionWorkflowHasMetricFields: "<",
    handleOpenCascadingForm: "<",
    canCascadeMetric: "<",
    copyItemUrlToClipboard: "<",
  },
};
